import { Log } from "@/interfaces/Log.ts";
import { PaginatedResponse, Pagination } from "@/interfaces/paginatedResponse.ts";
import axios from "@/lib/axios.ts";
import { useAuthStore } from "@/stores/auth";
import { useLogsStore } from "@/stores/Log.ts";
import { useQuery } from "@tanstack/vue-query";
import _ from "lodash";
import { storeToRefs } from "pinia";
import { Ref, watch } from "vue";

interface Params {
  id: string | number;
  page?: number | string;
}

interface Props {
  immediate?: boolean;
  params: Params;
}

const getUserLog = async (params: Params) => {
  const { data } = await axios.get<PaginatedResponse<Log>>(
    `api/users/${params.id}/logs?page=${params.page || 1}`,
  );

  return data;
};

const useUserLog = (props: Props) => {
  const { immediate = true, params } = props;
  const { user } = useAuthStore();

  const { setLog, setPage, setPagination } = useLogsStore();
  const { logs, page, pagination } = storeToRefs(useLogsStore());

  const { data, isLoading, refetch } = useQuery(
    ["userLog", params.id],
    () =>
      getUserLog({
        id: params.id,
        page: page.value,
      }),
    {
      enabled: immediate,
    },
  );

  watch(
    data,
    (value) => {
      if (value) {
        // Corregir el problema de 'roperties' vs 'properties'
        const correctedLogs = value.data.map(log => {
          // Si el log tiene 'roperties' pero no 'properties'
          if ((log as any).roperties && !log.properties) {
            return {
              ...log,
              properties: (log as any).roperties // Copiar 'roperties' a 'properties'
            };
          }
          return log;
        });

        setLog(
          correctedLogs.filter((log) => {
            if (user?.internal) {
              return true;
            }

            if (!log.properties?.isInternal) {
              return true;
            }
            
            return false;
          }),
        );
        setPagination(_.omit(value, ["data"]) as Pagination);
      }
    },
    {
      immediate,
    },
  );

  return {
    logs,
    pagination,
    isLoading,
    refetch,
    setPage,
    page,
  };
};

export default useUserLog;